import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap';
import { DoubleBounce } from 'better-react-spinkit'

import Masonry from 'react-masonry-component';
import config from 'react-global-configuration';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

import { NavSpacer, LightBackground, SpinnerWrapper, LogeButton } from '../components/GeneralStyle'
import CompanyCard from '../components/internal/CompanyCard'
import { InfoBox, Uppercase } from '../components/OnePager/OnePageStyle'
import PartnerGrid from '../components/partner/PartnerGrid'

import styled from 'styled-components'
import './PartnerOverview.css'

@inject('partnerInformationStore')
@observer
class PartnerOverview extends Component {

  constructor(props) {
    super(props)

    this.state = {
      limitTiles: false,
      initalTileCount: 8
    }
  }

  render() {

    let industries = [];

    const masonryOptions = {
      transitionDuration: 200
    };

    const industryData = this.props.partnerInformationStore.industries

    industryData.map((industry, key) => {
      return industries.push(
        <Col xs={6} sm={6} md={4} lg={3} style={{ padding: 0 }} key={key}>
          <IndustryCard imageUrl={industry.image} onClick={() => this.props.history.push("/industry/" + industry.slug)}>
            <IndustryBackground />
            <IndustryTitle style={{textAlign: 'center', zIndex: 2}}>{ industry.name }</IndustryTitle>
            <div style={{zIndex: 2}}>{ (industry && industry.count) ? industry.count == 1 ? "1 Firma" : industry.count + " Firmen" : "0 Firmen"}</div>
          </IndustryCard>
        </Col>
      )
    })

    const filteredIndustries = this.state.limitTiles ? industries.slice(0, this.state.initalTileCount) : industries

    return (
      <Grid fluid>
        <div className="pageWrapper" style={{marginTop: '60px', background: '#f5f5f5'}}>
          <NavSpacer />
          <div style={{background: 'linear-gradient(131.45deg, rgba(255, 255, 255, 0.5) -17.18%, rgba(255, 255, 255, 0) 57.6%), #DAB777'}}>
            <InfoBox className={'content-wrapper'} style={{paddingBottom: 160}}>
              <IndustryGrid>
                <h1 style={{marginBottom: '32px'}}>Unser Netzwerk</h1>
                <Masonry
                  className={"industryGrid"}
                  style={{width: '100%'}}
                  options={masonryOptions}
                  disableImagesLoaded={false}
                  updateOnEachImageLoad={true}>
                  {
                    filteredIndustries
                  }
                </Masonry>
              </IndustryGrid>
              {this.state.limitTiles &&
                <div style={{display: 'flex', justifyContent: 'center', marginTop: '32px'}}>
                  <LogeButton id="load-more-button" style={{background: "#212D3D", fontWeight: 400}} color={"#212D3D"} hoverFontColor={"#212D3D"} fontColor={"white"} onClick={() => { this.setState({limitTiles:false}) }}>Alle anzeigen</LogeButton>
                </div>
              }

            </InfoBox>
          </div>
          <PartnerGrid />
        </div>
      </Grid>
    )
  }
}

const IndustryGrid = styled.div`
  width: 100%;
  min-height: 40vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const IndustryCard = styled.div`
  position: relative;
  background: #555;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
  background-image: url(${props => props.imageUrl});
  background-position: center;
  background-size: cover;
  cursor: pointer;
  margin: 15px;
  border-radius: 4px;
  transition: all 0.3s ease;
  height: 144px;

  @media (max-width: 768px){
    font-size: 12px;
    padding: 16px;
    margin: 8px;
    min-height: 94px;
    height: auto;
  }

  :hover {
    box-shadow: 2px 2px 16px rgba(0,0,0,0.3);
    transform: scale(0.99);
  }
`

const IndustryTitle = styled.div`
  font-size: 20px;
  @media (max-width: 768px){
    font-size: 16px;
  }
`

const IndustryBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(0deg,rgba(0,0,0,0.4) 0%,rgba(0,0,0,0.12) 75%);
`

export default withRouter(PartnerOverview);



// WEBPACK FOOTER //
// /src/pages/PartnerOverview.js